<script>
import axios from 'axios';
import { diagonalbackURL, defaultConfig } from "../constantes";

export default {
    methods : {
        errorHandler(error) {
            console.log(error);

        },
        noEmpty(field){
            return (field != undefined) && (field != null) && (field != '') && (field != -1);
        },
        downloadFile(filename, content) {
            // create file link in browser's memory
            const href = URL.createObjectURL(new Blob([content], {type:'application/octet-binary'}));

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        },
        async areSettingsLocked(error) {
            var areLocked = false;

            if (error.response.status == 503) {
                const response = await axios(diagonalbackURL + "/settings/lock", defaultConfig);
                areLocked = response.data;
            }

            return areLocked;
        },
        async copyToClipboard(textToCopy) {
            // Si le navigateur se trouve dans un contexte sécurisé (https / localhost)
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(textToCopy);
            } else {
                // Sinon on utilise une box en dehors de la zone visible
                const textArea = document.createElement("textarea");
                textArea.value = textToCopy;
                    
                // On la deplace dans une zone invisible
                textArea.style.position = "absolute";
                textArea.style.left = "-999999px";
                    
                document.body.prepend(textArea);
                textArea.select();

                try {
                    document.execCommand('copy');
                } catch (error) {
                    console.error(error);
                } finally {
                    textArea.remove();
                }
            }
        }
    }
}
</script>